"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFdrTravelDatesState = exports.fdrTravelDatesReducer = exports.updateReturnDate = exports.updateDuration = void 0;
const addDays_1 = __importDefault(require("date-fns/addDays"));
const use_effect_reducer_1 = require("use-effect-reducer");
const libs_tracking_1 = require("@hotelplan/libs.tracking");
const fdr_travel_dates_mappers_1 = require("./fdr-travel-dates.mappers");
const fdr_travel_dates_utils_1 = require("./fdr-travel-dates.utils");
const fdr_travel_dates_types_1 = require("./fdr-travel-dates.types");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
function findDurationValueByDateRange(dateRange, durationValues) {
    return durationValues.find(durationValue => {
        const durationInDays = (0, fdr_travel_dates_utils_1.getMinDurationInDays)(durationValue);
        return durationInDays === dateRange;
    });
}
function updateDuration(departureDate, returnDate, currentDuration, durationValues, searchType) {
    if (!returnDate)
        return currentDuration;
    const dateRange = (0, fdr_travel_dates_mappers_1.calculateDateRange)(returnDate, departureDate);
    if (searchType === supergraph_api_1.FdrTravelPeriodType.Exact) {
        return {
            duration: [dateRange],
            type: 'night',
        };
    }
    const currentMinDuration = (0, fdr_travel_dates_utils_1.getMinDurationInDays)(currentDuration);
    const updatedDuration = findDurationValueByDateRange(dateRange, durationValues);
    return dateRange < currentMinDuration ? updatedDuration : currentDuration;
}
exports.updateDuration = updateDuration;
function updateReturnDate(returnDate, departureDate, duration) {
    // If returnDate does not exist we should calculate it returnDate = departureDate + maxDuration
    if (!returnDate)
        return (0, addDays_1.default)(departureDate, (0, fdr_travel_dates_utils_1.getMaxDurationInDays)(duration));
    // If returnDate exists we should check if date range is less than MAX_DATE_RANGE_ON_EXACT_SEARCH, if no we should calculate returnDate = departureDate + MAX_DATE_RANGE_ON_EXACT_SEARCH
    const dateRange = (0, fdr_travel_dates_mappers_1.calculateDateRange)(returnDate, departureDate);
    return dateRange < fdr_travel_dates_utils_1.MAX_DATE_RANGE_ON_EXACT_SEARCH
        ? returnDate
        : (0, addDays_1.default)(departureDate, (0, fdr_travel_dates_utils_1.getMaxDurationInDays)(duration));
}
exports.updateReturnDate = updateReturnDate;
function fdrTravelDatesReducer(state, action, exec) {
    const getNewState = () => {
        var _a, _b;
        switch (action.type) {
            case fdr_travel_dates_types_1.FdrTravelDatesActionTypes.RESET_DATES: {
                const { duration, departureDate, returnDate, searchType } = state;
                const { departureDate: newDepartureDate, returnDate: newReturnDate } = action.payload;
                const durationValues = (0, fdr_travel_dates_mappers_1.getDurationValuesBySearchType)(searchType);
                const updatedDuration = updateDuration(newDepartureDate || departureDate, newReturnDate || returnDate, duration, durationValues, searchType);
                return Object.assign(Object.assign({}, state), { returnDate: newReturnDate || returnDate, departureDate: newDepartureDate || departureDate, duration: updatedDuration || duration });
            }
            case fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_DURATION: {
                const { duration } = action.payload;
                const maxDuration = (0, fdr_travel_dates_utils_1.getMaxDurationInDays)(duration);
                // If return date is not filled. Is it possible?
                // Because it can be calculated from duration + departure date, which are always filled
                if (!state.returnDate) {
                    return Object.assign(Object.assign(Object.assign({}, state), { returnDate: (0, fdr_travel_dates_mappers_1.calculateReturnDate)(state.departureDate, maxDuration) }), action.payload);
                }
                // If user selects duration that is longer than travel date range,
                // the return date is automatically changed according to the duration value (departure date + duration)
                const dateRange = (0, fdr_travel_dates_mappers_1.calculateDateRange)(state.returnDate, state.departureDate);
                if (maxDuration > dateRange) {
                    return Object.assign(Object.assign(Object.assign({}, state), { returnDate: (0, fdr_travel_dates_mappers_1.calculateReturnDate)(state.departureDate, maxDuration) }), action.payload);
                }
                // Otherwise leave as is
                return Object.assign(Object.assign({}, state), action.payload);
            }
            case fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_DEPARTURE_DATE: {
                // When travel date range in calendar is shorter than duration in duration dropdown
                const { departureDate: updatedDepartureDate } = action.payload;
                const { duration: currentDuration, returnDate: currentReturnDate, searchType, } = state;
                const durationValues = (0, fdr_travel_dates_mappers_1.getDurationValuesBySearchType)(searchType);
                const updatedDuration = updateDuration(updatedDepartureDate, currentReturnDate, currentDuration, durationValues, searchType);
                return Object.assign(Object.assign({}, state), { duration: updatedDuration || currentDuration, departureDate: action.payload.departureDate });
            }
            case fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_RETURN_DATE: {
                // When travel date range in calendar is shorter than duration in duration dropdown
                const { returnDate: updatedReturnDate } = action.payload;
                const { duration: currentDuration, departureDate: currentDepartureDate, searchType, } = state;
                const durationValues = (0, fdr_travel_dates_mappers_1.getDurationValuesBySearchType)(searchType);
                const updatedDuration = updateDuration(currentDepartureDate, updatedReturnDate, currentDuration, durationValues, searchType);
                return Object.assign(Object.assign({}, state), { duration: updatedDuration || currentDuration, returnDate: action.payload.returnDate });
            }
            case fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_SEARCH_TYPE: {
                const shouldUseDefaults = action.payload.defaults
                    ? (0, fdr_travel_dates_utils_1.areTravelDatesEqual)(state, action.payload.searchType === supergraph_api_1.FdrTravelPeriodType.Flexible
                        ? action.payload.defaults.exact
                        : action.payload.defaults.flexible)
                    : false;
                // Switch from exact to flexible
                if (action.payload.searchType === supergraph_api_1.FdrTravelPeriodType.Flexible) {
                    if (shouldUseDefaults) {
                        return Object.assign(Object.assign(Object.assign({}, state), (_a = action.payload.defaults) === null || _a === void 0 ? void 0 : _a.flexible), { searchType: action.payload.searchType });
                    }
                    const isDurationValueInDefaultList = (0, fdr_travel_dates_utils_1.containsDurationValue)(state.duration, fdr_travel_dates_mappers_1.EXACT_DURATION_VALUES);
                    const updatedReturnDate = updateReturnDate(state.returnDate, state.departureDate, state.duration);
                    return Object.assign(Object.assign({}, state), { returnDate: updatedReturnDate, 
                        // When we switch from exact to flexible and there is no existing duration in duration dropdown
                        // we should add this duration to duration dropdown
                        extraDurations: isDurationValueInDefaultList
                            ? []
                            : [...state.extraDurations, state.duration], searchType: action.payload.searchType });
                }
                // Switch from flexible to exact
                if (action.payload.searchType === supergraph_api_1.FdrTravelPeriodType.Exact) {
                    if (shouldUseDefaults) {
                        return Object.assign(Object.assign(Object.assign({}, state), (_b = action.payload.defaults) === null || _b === void 0 ? void 0 : _b.exact), { searchType: action.payload.searchType });
                    }
                    const updatedReturnDate = updateReturnDate(state.returnDate, state.departureDate, state.duration);
                    const updatedDuration = {
                        duration: [
                            (0, fdr_travel_dates_mappers_1.calculateDateRange)(updatedReturnDate, state.departureDate),
                        ],
                        type: 'night',
                    };
                    return Object.assign(Object.assign({}, state), { returnDate: updatedReturnDate, duration: updatedDuration, extraDurations: [], searchType: action.payload.searchType });
                }
                return Object.assign(Object.assign({}, state), { extraDurations: [], searchType: action.payload.searchType });
            }
            case fdr_travel_dates_types_1.FdrTravelDatesActionTypes.CLEAR_DATE_RANGE: {
                return Object.assign(Object.assign({}, state), { returnDate: null, departureDate: action.payload.departureDate });
            }
            default:
                throw Error();
        }
    };
    const newState = getNewState();
    if (action.type === fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_SEARCH_TYPE) {
        exec({ type: 'trackSwitch' });
    }
    else if (action.type !== fdr_travel_dates_types_1.FdrTravelDatesActionTypes.RESET_DATES) {
        exec({ type: 'trackOther' });
    }
    return newState;
}
exports.fdrTravelDatesReducer = fdrTravelDatesReducer;
function useFdrTravelDatesState(initialState) {
    const [state, dispatch] = (0, use_effect_reducer_1.useEffectReducer)(fdrTravelDatesReducer, initialState, {
        trackSwitch: currState => {
            (0, libs_tracking_1.trackTravelDates)({
                type: libs_tracking_1.TravelDatesEventType.TRAVEL_DATES_SWITCH,
                payload: {
                    exact: currState.searchType === supergraph_api_1.FdrTravelPeriodType.Exact,
                },
            });
        },
        trackOther: currState => {
            (0, libs_tracking_1.trackTravelDates)({
                type: libs_tracking_1.TravelDatesEventType.TRAVEL_DATES_UPDATE,
                payload: (0, fdr_travel_dates_mappers_1.mapTravelDatesModalToTrackableTravelDates)(currState),
            });
        },
    });
    const setSearchType = (searchType, defaults) => {
        dispatch({
            type: fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_SEARCH_TYPE,
            payload: { searchType, defaults },
        });
    };
    const setDepartureDate = (departureDate) => {
        dispatch({
            type: fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_DEPARTURE_DATE,
            payload: { departureDate },
        });
    };
    const setReturnDate = (returnDate) => {
        dispatch({
            type: fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_RETURN_DATE,
            payload: { returnDate },
        });
    };
    const resetDates = ({ returnDate, departureDate, }) => {
        dispatch({
            type: fdr_travel_dates_types_1.FdrTravelDatesActionTypes.RESET_DATES,
            payload: { returnDate, departureDate },
        });
    };
    const setDuration = (durationValue) => {
        dispatch({
            type: fdr_travel_dates_types_1.FdrTravelDatesActionTypes.SET_DURATION,
            payload: { duration: durationValue },
        });
    };
    const clearDateRange = (departureDate) => {
        dispatch({
            type: fdr_travel_dates_types_1.FdrTravelDatesActionTypes.CLEAR_DATE_RANGE,
            payload: { departureDate: departureDate },
        });
    };
    return {
        state,
        setSearchType,
        setDepartureDate,
        setReturnDate,
        setDuration,
        clearDateRange,
        resetDates,
    };
}
exports.useFdrTravelDatesState = useFdrTravelDatesState;
//# sourceMappingURL=fdr-travel-dates.model.js.map